export const TEAM_NAME_MAX_LENGTH = 256;

export function validateTeamName(value: string): string {
    // Cannot be empty
    if (value.length === 0) {
        return 'shared.fields.team_name.error_required';
    }

    // Cannot be greater than 256 characters
    if (value.length > TEAM_NAME_MAX_LENGTH) {
        return 'shared.fields.team_name.error_too_long';
    }

    return '';
}
